// src/components/BackButton.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const BackButton = ({ path, className = '', label = 'Go back' }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (path) {
      navigate(path);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      className={`app-back-button ${className}`.trim()}
      aria-label={label}
      onClick={handleBackClick}
    >
      <FiArrowLeft aria-hidden="true" />
    </button>
  );
};

export default BackButton;
